module.exports = __webpack_public_path__ + "static/media/localizacion.91546184.png";